import React from "react";
import { CpuIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function Hero() {
  return <header className="w-full bg-canvas px-5 pb-14 pt-8 sm:pt-12" data-id="element-159" data-mp="9luxafjjzvqk">
      <div className="mx-auto max-w-4xl text-center" data-id="element-160" data-mp="4lyswf6y22ah">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-161" data-mp="4njpeactjvaz">
          <div className="flex items-center gap-2" data-id="element-162" data-mp="128607wumu8qj">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-white" data-id="element-163" data-mp="xae7x1q2sklt">
              <CpuIcon className="h-5 w-5" aria-hidden="true" data-id="element-164" data-mp="sb1bbp9ejz61" />
            </span>
            <span className="font-display text-lg font-extrabold text-navy" data-id="element-165" data-mp="sd4cn5g09eq2">BCM Diagnostic Blueprint™</span>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-brand/20 bg-white px-3 py-1 text-xs font-bold uppercase text-brand" data-id="element-166" data-mp="3d1a4l90jrr80">
            <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="3814c5qmge0ov" />
            For Automotive Technicians
          </span>
        </div>

        <h1 className="mt-7 font-display text-[2.35rem] font-black leading-[1.05] tracking-tight text-navy sm:text-6xl" data-id="element-168" data-mp="3o85blc7uc353">
          Organize Your Next BCM Diagnostic Investigation in{" "}
          <em className="text-brand" data-id="element-169" data-mp="3e9fuhlnrqmpw">10 Minutes or Less</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted sm:text-xl" data-id="element-170" data-mp="3ebisarv5xk56">
          A step-by-step diagnostic organization system to help you classify symptoms, document evidence, and
          determine a logical next investigative step on Body Control Module faults. Includes{" "}
          <strong className="text-navy" data-id="element-171" data-mp="2qhqwboo9n411">6 professional volumes</strong>,{" "}
          <strong className="text-navy" data-id="element-172" data-mp="2vjg50xo0n5ly">5 exclusive bonuses</strong>, visual workflows, decision frameworks and
          case documentation tools.
        </p>

        <img src={images.mainMockup} alt="BCM Diagnostic Blueprint six-volume collection with five bonuses" className="mx-auto mt-8 w-full max-w-2xl" data-id="element-173" data-mp="2lla4ajdy45io" />

        <div className="mt-8" data-id="element-174" data-mp="nbl3anaa4kbi">
          <CtaButton id="hero-cta" note="Instant Download · One-Time Payment of $27 · Lifetime Access · 7-Day Money-Back Guarantee" data-id="element-175" data-mp="najg5kfzo7df">
            Yes! I Want the BCM Diagnostic Blueprint
          </CtaButton>
        </div>

        <div className="mt-8" data-id="element-176" data-mp="1b0w05toidukd">
          <Countdown data-id="element-177" data-mp="1azuktd0gmlwu" />
        </div>

        <p className="mx-auto mt-8 max-w-2xl rounded-xl bg-white p-4 text-xs leading-relaxed text-muted" data-id="element-178" data-mp="1b04a0ydokp1h">
          The 10-minute goal refers to organizing the initial investigation and identifying a logical next
          step—not necessarily diagnosing or repairing the underlying fault. Actual diagnostic time depends on the
          vehicle, symptoms, available information, and test results.
        </p>
        <p className="mt-4 text-sm font-semibold text-navy" data-id="element-179" data-mp="3lqm1dvdxqztc">
          Created by Jason Mitchell — Automotive Electronics Specialist
        </p>
      </div>
    </header>;
}